import { createFormHook, createFormHookContexts } from "@tanstack/react-form";

import RadioButton from "./components/fields/radio/RadioButton";
import YesNoRadioButton from "./components/fields/radio/YesNoRadioButton";
import AutocompleteSelect from "./components/fields/select/AutocompleteSelect";
import SelectField from "./components/fields/select/Select";
import HtmlEditor from "./components/fields/text/HtmlEditor";
import SearchBar from "./components/fields/text/SearchBar";
import TextInput from "./components/fields/text/TextInput";
import FormSection from "./components/layout/FormSection";

export const { fieldContext, formContext, useFieldContext, useFormContext } =
  createFormHookContexts();

// lets keep these alphabetical for easy lookup as this grows
export const { useAppForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    AutocompleteSelect,
    HtmlEditor,
    RadioButton,
    SearchBar,
    SelectField,
    TextInput,
    YesNoRadioButton,
  },
  formComponents: {
    FormSection,
  },
});

export type AppFormType = ReturnType<typeof useAppForm>;
